import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { IKeyValueInterface, WeGoAuthorizedLink, Permission, PermissionType, Entity } from './../../shared/config';
import { ContractTypeHistoryComponent } from './contractType-history.component';
import { ContractTypeGroupService } from './../../contracttypegroup/models/contracttypegroup.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ContractTypeModel } from '../models/contractType.model';
import { ContractTypeService } from '../models/contractType.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';

@Component({
  selector: 'wego-contracttype-list',
  template: require('../views/contractType-list.component.html'),
  providers: [ContractTypeService, ContractTypeGroupService],
})
export class ContractTypeListComponent implements OnInit {
  DataListModel: DataListModel;
  contractTypeList: ContractTypeModel[];
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  isLoading: boolean;
  message: string;
  deletecontractTypeHashId: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  deleteMessage: string;
  contractTypeGroupHashId: string;
  sharedVehicleGroupHashId: string;
  urlDefaultPage: string;
  urlContractTypeList: string;
  urlContractTypeUpdate: string;
  urlContractTypeAdd:string;
  urlSVGList: string;
  urlContractTypeGroupList: string;
  contractGroupName: string;
  versionId: string;
  addContractTypeLink:WeGoAuthorizedLink;

  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;
  private contractTypeGroup: string;
  private sharedvehicleGroup: string;


  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('historyModal') public historyModal: any;
  @ViewChild('successPopup') public successPopup: any;

  get isAnyChecked(): boolean {
    if (this.contractTypeList) {
      let isCheck = this.contractTypeList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.contractTypeList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  get isDeleteAccess(): boolean {
    if (this.contractTypeList){
      return this.contractTypeList.some(x => x.isDeletable);
    }
    else{ return false; }
      
  }

  constructor(private contractTypeService: ContractTypeService
    , private contractTypeGroupService: ContractTypeGroupService
    , private activeRoute: ActivatedRoute
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblContractType');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.sharedvehicleGroup = this.translate.instant('LblListPage', [this.translate.instant('LblSharedVehicleGroup')]);
    this.contractTypeGroup = this.translate.instant('LblListPage', [this.translate.instant('LblContractTypeGroup')]);

    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["contractName", "sunFlag", "monFlag", "tueFlag", "wedFlag", "thuFlag", "friFlag", "satFlag", "contractTypeType"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlContractTypeList = this.authService.GetURL(ApplicationRouteURL.URL_CONTRACT_TYPE_LIST);
    this.urlContractTypeUpdate = this.authService.GetURL(ApplicationRouteURL.URL_CONTRACT_TYPE_UPDATE);
    this.urlContractTypeAdd = this.authService.GetURL(ApplicationRouteURL.URL_CONTRACT_TYPE_ADD);
    this.urlSVGList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.urlContractTypeGroupList = this.authService.GetURL(ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST);
    this.activeRoute
      .params
      .subscribe(params => {
        this.contractTypeGroupHashId = params['contractTypeGroupHashId'] || '';
        this.sharedVehicleGroupHashId = params['sharedVehicleGroupHashId'] || '';
        if (this.contractTypeGroupHashId) {
          this.GetContractTypeGroupDetailsByHashId();
          
          this.addContractTypeLink = new WeGoAuthorizedLink(this.urlContractTypeAdd + '/' + this.sharedVehicleGroupHashId + '/' + this.contractTypeGroupHashId ,
          Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW, PermissionType.INSERT
          , 'btn btn-highlight navbar-right', 'LblAddNew', Entity.SVG, this.sharedVehicleGroupHashId);

          this.GetContractTypeList();
        }
      });
  }

  public GetContractTypeGroupDetailsByHashId() {
    this.contractTypeGroupService.GetContractTypeGroupBasicDetail(this.contractTypeGroupHashId)
      .subscribe(
      res => {
        if (res.data)
          this.contractGroupName = res.data.entityName;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public GetContractTypeList() {
    this.isLoading = true;
    this.contractTypeService.GetContractTypeList(this.contractTypeGroupHashId, this.DataListModel)
      .subscribe(
      res => {
        this.contractTypeList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetContractTypeList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetContractTypeList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetContractTypeList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetContractTypeList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.contractTypeService.ExportContractTypeList(this.contractTypeGroupHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "ContractType" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }

  public OnParentCheck(isChecked: boolean) {
    this.contractTypeList.filter(x => x.isDeletable).forEach(x => x.isChecked = isChecked);
  }

  public DeleteContractType(deleteContractTypeHashId: string[]) {
    this.isLoading = true;
    this.contractTypeService.DeleteContractType(deleteContractTypeHashId, this.contractTypeGroupHashId)
      .subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetContractTypeList();
        this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
        this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowAlertModal(contractTypeHashId?: string): void {
    if (contractTypeHashId) {
      this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deletecontractTypeHashId = contractTypeHashId;
    }
    else {
      this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;
    }
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.deletecontractTypeHashId = "";
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    let deleteContractTypeList: any[];
    if (this.isMultipleDelete)
      deleteContractTypeList = this.contractTypeList.filter(x => x.isChecked).map(x => x.contractTypeHashId);
    else
      deleteContractTypeList.push(this.deletecontractTypeHashId);

    this.DeleteContractType(deleteContractTypeList)
    this.alertModal.hide();
  }

  public ShowContractTypeHistory(versionId: string) {
    this.historyModal.versionId = versionId;
    this.historyModal.show();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/contractType/components/contractType-list.component.ts